import React, { useEffect } from 'react';

import { observer } from 'mobx-react';
import classNames from 'classnames';

import { InfoBox } from '@infoods/lifebase-ui';
import classes from './NgzQuestionnaiteTab.module.scss';
import { AnswerItem } from './AnswerItem/AnswerItem';
import { getRouteParam } from '../../../../../shared/utils/angularUtils';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../shared/constants/apiDateFormat';
import { questionnaireReplyStore } from '../../../../stores/questionnaireReplyStore';
import { angularizeWithProviders } from '../../../../../shared/providers';

const NgzQuestionnaireTab = observer(() => {
  const customerId = getRouteParam('id');

  const { createdOn, questionReply, getCustomerQuestionnaire, setDefaultValues } =
    questionnaireReplyStore;

  useEffect(() => {
    getCustomerQuestionnaire(customerId);

    return () => {
      setDefaultValues();
    };
  }, [customerId]);

  return (
    <InfoBox
      title="Questionnaire"
      customContentPadding
      adornment={
        <p className={classNames(classes.createdAt, 'private-info')}>
          Created: {getFormattedDate(createdOn, localDataFormat)}
        </p>
      }
    >
      {questionReply.map((reply, index) => (
        <AnswerItem
          key={reply.questionId}
          questionNumber={index + 1}
          question={reply.name || ''}
          answer={reply.answer.name}
        />
      ))}
    </InfoBox>
  );
});

angularizeWithProviders(NgzQuestionnaireTab, 'ngzQuestionnaireTab', {});
